// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

h1 {
  font-size: 1.5rem;
}

mat-paginator {
  direction: ltr;
  margin: auto !important;
}

.text-item {
  text-align: center;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/identification/identification.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/identification/identification.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACCF;;ADCA;EACE,eAAA;EACE,iBAAA;ACEJ;;ADAA;EACE,iBAAA;ACGF;;ADDA;EACE,cAAA;EACA,uBAAA;ACIF;;ADIA;EACE,kBAAA;ACDF;;ADGA;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACAF","sourcesContent":[".title{\r\n  margin-bottom: 10px;\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\nmat-icon{\r\n  font-size: 26px; \r\n    margin-left: 10px;\r\n}\r\nh1{\r\n  font-size: 1.5rem;\r\n}\r\nmat-paginator{\r\n  direction: ltr;\r\n  margin: auto !important;\r\n}\r\n\r\n// ::ng-deep .mat-paginator-container {\r\n//   margin: auto !important;\r\n//   display: flex !important;\r\n//   justify-content: center !important;\r\n// }\r\n.text-item{\r\n  text-align: center;\r\n}\r\n.parent-both{\r\n  display: flex;\r\n  margin: auto;\r\n  padding: 20px;\r\n}",".title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\nmat-paginator {\n  direction: ltr;\n  margin: auto !important;\n}\n\n.text-item {\n  text-align: center;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
